import { defineStore } from 'pinia'
import axios from 'axios'
import { ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const useInvoiceStore = defineStore('InvoiceStore', {
    state: () => {
        return {
            invoice: null,
            type: ref(1),
            invoice_id: ref(null),
            route: useRoute(),
            router: useRouter(),
        }
    },
    actions: {
        async fetchInvoice() {
            const route = this.router.resolve(
                {
                    name: 'invoice-list'
                }
            );
            try {
                this.invoice = await axios.post(route.href)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {
                console.log(error);
            }
        }
    },
    getters: {
    },
})